import { render } from "./PayloadJson.vue?vue&type=template&id=07588039&scoped=true"
import script from "./PayloadJson.vue?vue&type=script&lang=js"
export * from "./PayloadJson.vue?vue&type=script&lang=js"

import "./PayloadJson.vue?vue&type=style&index=0&id=07588039&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07588039"]])

export default __exports__